
import { TextField } from '@material-ui/core';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import { Autocomplete, Button, Card, Paper } from "@mui/material";
import { Stack } from "@mui/system";
import { DataGrid } from '@mui/x-data-grid';
import { default as React, useState } from "react";
import * as XLSX from "xlsx";
import Nabvar from "../../common/Nabvar";
import Sidebar from "../../common/Sidebar";
import axios from "../../config/authaxios";
import { useStyles } from '../../theme/theme';
import Body from "../../ui/Body";
import "../../css/index.css"
// import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function Upload() {
  const [couponList, setCouponList] = useState([])
  const [isProcess, setIsProcess] = useState(false)
  const classes = useStyles();
  const [pageSize, setPageSize] = useState(25);
  const platformValue = [{
    name: "Gamerpe",
    value: 1
  },
  {
    name: "TopUp-X",
    value: 2
  }]
  const [platform, setPlatform] = useState(1);
  const [open,setOpen]=useState(false)
  const [list,setList]=useState([])
  const handlefileInputExcel = (e) => {
    let ExcelFile = e.target.files[0];
    e.preventDefault();
    var reader = new FileReader();
    reader.onload = function (e) {
      var data = e.target.result;
      let readedData = XLSX.read(data, { type: "binary" });
      var sheet_name_list = readedData.SheetNames;
      var lists = XLSX.utils.sheet_to_json(
        readedData.Sheets[sheet_name_list[0]]
      );
      setCouponList(lists)
    };
    reader.readAsBinaryString(ExcelFile);
  };

  const handlesumbitMutiquestion = () => {
    console.log(platform)
    setIsProcess(true)
    axios
      .post("/admin/upload-coupons", {
        platform: platform, // 1 is gamerpe coupon and 2 is topupx Coupon
        coupon_lists: couponList
      })
      .then((res) => {
        console.log("res-->",res)
        alert(res.data.message)

        if (res.data.response.length>0) {
          setOpen(true)
          setList([...res.data.response])
        } 
      });
    setIsProcess(false)
    setCouponList([])

  };

  const handleClose=()=>{
    setOpen(false)
  }

  const CouponsColomns = [
    {
      field: 's_no',
      headerName: 'S. No.',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      filterable: false,
      renderCell: (index) => index.api?.getRowIndexRelativeToVisibleRows(index.row.__rowNum__) + 1,
    },
    {
      field: 'code',
      headerName: 'Code',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'name',
      headerName: 'Name',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'price',
      headerName: 'Price',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
  ]




  return (
    <>
      <Sidebar />
      <Nabvar />
      <Body>
        <Card sx={{ p: 4 }}>
          <div className='platFormBox'>
            <h2>Platform</h2>
            <Autocomplete
              disablePortal
              className='platformAutoComplete'
              options={
                platformValue
              }
              onChange={(event, newValue) => {
                setPlatform(newValue?.value);
              }}
              getOptionLabel={option => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Platform"
                />
              )}
            />
          </div>
          <Stack spacing={2} direction='row'>
            <label htmlFor="contained-button-file">
              <input
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                id="contained-button-file"
                type="file"
                onChange={handlefileInputExcel}
                disabled={isProcess}

                style={{ display: 'none' }}
              />
              <Button
                variant="contained"
                component="span"
                endIcon={<DriveFolderUploadIcon />}
                color="info"
              >
                Upload Coupons
              </Button>

            </label>
            <Button disabled={isProcess || !couponList?.length} variant='contained' onClick={handlesumbitMutiquestion}>Submit</Button>
          </Stack>
        </Card>

        {couponList?.length ?
          <Card sx={{ p: 2, mt: 1 }}>
            <Paper sx={{
              bgcolor: '#fff',
              '& .super-app-theme--header': {
                bgcolor: '#DC8449',
                color: '#fff',
              },
            }} elevation={0}>

              <DataGrid
                className={classes.root}
                sx={{
                  border: 0,
                }}
                hideFooterPagination
                // getRowHeight={() => 'auto'}
                autoHeight
                rows={couponList || []}
                columns={CouponsColomns}
                getRowId={(row) => row.__rowNum__}
                disableSelectionOnClick
                disableRowSelectionOnClick
                experimentalFeatures={{ newEditingApi: true }}
                pagination
                pageSize={pageSize}
                disableColumnSelector
              />
            </Paper>
          </Card>
          : null}

      </Body>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Duplicate Coupon List"}
        </DialogTitle>
        <DialogContent>
        <h5>Total Duplicate Number:{list.length}</h5>
      <ul>
        {list.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
          {/* <Button onClick={handleClose} autoFocus>
            Agree
          </Button> */}
        </DialogActions>
      </Dialog>
    </>
  );
}
